// components/FieldRow.tsx
import React from 'react';
import { SimpleGrid } from '@mantine/core';
import { BuilderField, FieldRowGroup } from '../types/BuilderField';
import { columnSpan } from '../utils/fieldWidth';
import { FieldCard } from './FieldCard';

export interface FieldRowProps {
  row: FieldRowGroup;
  readonly?: boolean;
  onEdit: (field: BuilderField) => void;
  onDelete: (field: BuilderField) => void;
  onMove: (field: BuilderField, dir: -1 | 1) => void;
}

/** Represents exactly one order number — 1 field renders full width, 2 render half/half. */
export function FieldRow({ row, readonly, onEdit, onDelete, onMove }: FieldRowProps) {
  const span = columnSpan(row.fields.length);
  return (
    <SimpleGrid cols={12} spacing="sm">
      {row.fields.map((field) => (
        <FieldCard
          key={field.id}
          field={field}
          span={span}
          readonly={readonly}
          onEdit={() => onEdit(field)}
          onDelete={() => onDelete(field)}
          onMove={(dir) => onMove(field, dir)}
        />
      ))}
    </SimpleGrid>
  );
}